import * as React from 'react';
import {Box} from '@mui/material';
import {useE4ImpactProjectsContext} from '../../context';
import {ChartsContainer} from '../../Common/ChartsContainer';
import {configSchema} from './configSchema';

export function Impact() {
    const {
        baselineSubmissions,
        finalSubmissions,
    } = useE4ImpactProjectsContext();

    return (
        <Box>
            <ChartsContainer
                configSchema={configSchema({
                    baselineSubmissions,
                    finalSubmissions,
                })}
            />
        </Box>
    )
}